<template>
  <div class="MetaDataInfobox">
    <ModuleName :ModouleName="ModouleName"></ModuleName>
    <div class="MetaDataInfo">
      <div class="type_box">
        <div class="type">
          {{ $t("DataDetails.mateInfo.productNumber") }} ：
        </div>
        <div class="type_val">{{ MetaDataInfo.productNum }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.dataType") }}：</div>
        <div class="type_val">{{ MetaDataInfo.name }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.dataFormat") }}：</div>
        <div class="type_val">{{ MetaDataInfo.dataFormat }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.Projection") }}：</div>
        <div class="type_val">{{ MetaDataInfo.projection }}</div>
      </div>

      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.startDate") }}：</div>
        <div class="type_val">{{ MetaDataInfo.startTime }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.endDate") }}：</div>
        <div class="type_val">{{ MetaDataInfo.endTime }}</div>
      </div>
      <div class="type_box">
        <div class="type">
          {{ $t("DataDetails.mateInfo.spatialResolution") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.spatialRes }}</div>
      </div>
      <div class="type_box">
        <div class="type">
          {{ $t("DataDetails.mateInfo.timeResolution") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.temporalRes }}</div>
      </div>
      <div class="type_box">
        <div class="type">
          {{ $t("DataDetails.mateInfo.geographicalScope") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.territorialScope }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.sharingMethod") }}：</div>
        <div class="type_val">
          {{
            MetaDataInfo.sharingMethod == 1
              ? $t("DataDetails.mateInfo.sharing1")
              : $t("DataDetails.mateInfo.sharing2")
          }}
        </div>
      </div>

      <div class="type_box">
        <div class="type">
          {{ $t("DataDetails.mateInfo.createInstitution") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.releaseMech }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.createdBy") }}：</div>
        <div class="type_val">{{ MetaDataInfo.creator }}</div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.creationDate") }}：</div>
        <div class="type_val">{{ MetaDataInfo.createTime }}</div>
      </div>

      <!-- <div class="type_box">
        <div class="type">学科分类：</div>
        <div class="type_val">{{ MetaDataInfo.subClassify }}</div>
      </div> -->

      <div class="type_box type_100">
        <div class="type">{{ $t("DataDetails.mateInfo.dataLabel") }}：</div>
        <div class="type_val">
          <div
            class="arr_for"
            v-for="(item, index) in MetaDataInfo.keywords.split(';')"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="type_box">
        <div class="type">{{ $t("DataDetails.mateInfo.sdgGoal") }}：</div>
        <div class="type_val">
          <div
            class="key_img"
            v-for="(k, j) in MetaDataInfo.sdgGoalIcon.split(',')"
            :key="j"
            style="width: 30px; height: 30px; margin: 2px"
          >
            <img :src="`${GLOBAL.imageUrl}${k}`" width="100%" alt />
          </div>
        </div>
      </div>

      <div class="type_box type_100">
        <div class="type">
          {{ $t("DataDetails.mateInfo.processingMethod") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.dataProcessing }}</div>
      </div>
      <div class="type_box type_100">
        <div class="type">{{ $t("DataDetails.mateInfo.QuoteAddress") }}：</div>
        <div class="type_val nowarp">{{ MetaDataInfo.dataQuote }}</div>
      </div>

      <div class="type_box type_100">
        <div class="type">
          {{ $t("DataDetails.mateInfo.copyrightNotice") }}：
        </div>
        <div class="type_val">{{ MetaDataInfo.copyrightState }}</div>
      </div>
    </div>
    <div class="metaDataInfoBtn">
      <Button
        v-for="(item, index) in btnData"
        :key="index"
        :Data="item"
        @click.native="metaDataInfoBtnFun(index)"
      ></Button>
    </div>
    <el-dialog
      :title="$t('DataDetails.metadataDetails')"
      :visible.sync="metaDataInfoVisible"
      max-width="60%"
      :before-close="handleClose"
    >
      <div class="el_dialog_box">
        <table id="tableObj" style="border-collapse: collapse" border="1">
          <tr style="width: 100%">
            <td rowspan="14">
              {{ $t("DataDetails.mateInfo.basicInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.subProjectNumber") }}</td>
            <td>{{ MetaDataInfo.subjectNum }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.productNumber") }}</td>
            <td>{{ MetaDataInfo.productNum }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataObject") }}</td>
            <td>{{ MetaDataInfo.productName }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataIdentification") }}</td>
            <td>{{ MetaDataInfo.dataId }}</td>
          </tr>
          <!-- <tr>
          <td>引用地址</td>
          <td>{{MetaDataInfo.dataId}}</td>
        </tr> -->
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataType") }}</td>
            <td>{{ MetaDataInfo.name }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Description") }}</td>
            <td>{{ MetaDataInfo.introduction }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataLabel") }}</td>
            <td>{{ MetaDataInfo.keywords }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.subjectClassification") }}</td>
            <td>{{ MetaDataInfo.subClassify }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.subjectClassification") }}</td>
            <td>{{ MetaDataInfo.product_classify }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.productType") }}</td>
            <td>{{ MetaDataInfo.product_type }}</td>
          </tr>

          <tr>
            <td>{{ $t("DataDetails.mateInfo.Projection") }}</td>
            <td>{{ MetaDataInfo.projection }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.processingMethod") }}</td>
            <td>{{ MetaDataInfo.dataProcessing }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.format") }}</td>
            <td>{{ MetaDataInfo.dataFormat }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.scopeDescription") }}</td>
            <td>{{ MetaDataInfo.territorialScope }}</td>
          </tr>
          <tr>
            <td rowspan="2">{{ $t("DataDetails.mateInfo.dateScope") }}</td>
            <td>{{ $t("DataDetails.mateInfo.startDate") }}</td>
            <td>{{ MetaDataInfo.startTime }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.endDate") }}</td>
            <td>{{ MetaDataInfo.endTime }}</td>
          </tr>
          <tr>
            <td rowspan="2">{{ $t("DataDetails.mateInfo.resolution") }}</td>
            <td>{{ $t("DataDetails.mateInfo.timeResolution") }}</td>
            <td>{{ MetaDataInfo.temporalRes }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.spatialResolution") }}</td>
            <td>{{ MetaDataInfo.spatialRes }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.copyright") }}</td>
            <td>{{ $t("DataDetails.mateInfo.copyrightNotice") }}</td>
            <td>{{ MetaDataInfo.copyrightState }}</td>
          </tr>

          <tr>
            <td rowspan="3">
              {{ $t("DataDetails.mateInfo.creatingInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.createInstitution") }}</td>
            <td>{{ MetaDataInfo.createInsti }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.createdBy") }}</td>
            <td>{{ MetaDataInfo.creator }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.creatingInformation") }}</td>
            <td>{{ MetaDataInfo.createTime }}</td>
          </tr>
          <tr>
            <td rowspan="3">{{ $t("DataDetails.mateInfo.releaseNews") }}</td>
            <td>{{ $t("DataDetails.mateInfo.releaseAgency") }}</td>
            <td>{{ MetaDataInfo.releaseMech }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Email") }}</td>
            <td>{{ MetaDataInfo.email }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Phone") }}</td>
            <td>{{ MetaDataInfo.telphone }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.updateDate") }}</td>
            <td>{{ $t("DataDetails.mateInfo.latestRelease") }}</td>
            <td>{{ MetaDataInfo.updateTime }}</td>
          </tr>
          <tr>
            <td rowspan="2">
              {{ $t("DataDetails.mateInfo.fileInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.totalStorage") }}</td>
            <td>{{ MetaDataInfo.storageCapacity }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.totalFiles") }}</td>
            <td>{{ MetaDataInfo.totalFile }}</td>
          </tr>
        </table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="metaDataInfoVisible = false">{{
          $t("DataDetails.close")
        }}</el-button>
      </span>
    </el-dialog>
       <table v-show="false" id="tableObjs" style="border-collapse: collapse" border="1">
          <tr style="width: 100%">
            <td rowspan="14">
              {{ $t("DataDetails.mateInfo.basicInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.subProjectNumber") }}</td>
            <td>{{ MetaDataInfo.subjectNum }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.productNumber") }}</td>
            <td>{{ MetaDataInfo.productNum }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataObject") }}</td>
            <td>{{ MetaDataInfo.productName }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataIdentification") }}</td>
            <td>{{ MetaDataInfo.dataId }}</td>
          </tr>
          <!-- <tr>
          <td>引用地址</td>
          <td>{{MetaDataInfo.dataId}}</td>
        </tr> -->
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataType") }}</td>
            <td>{{ MetaDataInfo.name }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Description") }}</td>
            <td>{{ MetaDataInfo.introduction }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.dataLabel") }}</td>
            <td>{{ MetaDataInfo.keywords }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.subjectClassification") }}</td>
            <td>{{ MetaDataInfo.subClassify }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.subjectClassification") }}</td>
            <td>{{ MetaDataInfo.product_classify }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.productType") }}</td>
            <td>{{ MetaDataInfo.product_type }}</td>
          </tr>

          <tr>
            <td>{{ $t("DataDetails.mateInfo.Projection") }}</td>
            <td>{{ MetaDataInfo.projection }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.processingMethod") }}</td>
            <td>{{ MetaDataInfo.dataProcessing }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.format") }}</td>
            <td>{{ MetaDataInfo.dataFormat }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.scopeDescription") }}</td>
            <td>{{ MetaDataInfo.territorialScope }}</td>
          </tr>
          <tr>
            <td rowspan="2">{{ $t("DataDetails.mateInfo.dateScope") }}</td>
            <td>{{ $t("DataDetails.mateInfo.startDate") }}</td>
            <td>{{ MetaDataInfo.startTime }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.endDate") }}</td>
            <td>{{ MetaDataInfo.endTime }}</td>
          </tr>
          <tr>
            <td rowspan="2">{{ $t("DataDetails.mateInfo.resolution") }}</td>
            <td>{{ $t("DataDetails.mateInfo.timeResolution") }}</td>
            <td>{{ MetaDataInfo.temporalRes }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.spatialResolution") }}</td>
            <td>{{ MetaDataInfo.spatialRes }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.copyright") }}</td>
            <td>{{ $t("DataDetails.mateInfo.copyrightNotice") }}</td>
            <td>{{ MetaDataInfo.copyrightState }}</td>
          </tr>

          <tr>
            <td rowspan="3">
              {{ $t("DataDetails.mateInfo.creatingInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.createInstitution") }}</td>
            <td>{{ MetaDataInfo.createInsti }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.createdBy") }}</td>
            <td>{{ MetaDataInfo.creator }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.creatingInformation") }}</td>
            <td>{{ MetaDataInfo.createTime }}</td>
          </tr>
          <tr>
            <td rowspan="3">{{ $t("DataDetails.mateInfo.releaseNews") }}</td>
            <td>{{ $t("DataDetails.mateInfo.releaseAgency") }}</td>
            <td>{{ MetaDataInfo.releaseMech }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Email") }}</td>
            <td>{{ MetaDataInfo.email }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.Phone") }}</td>
            <td>{{ MetaDataInfo.telphone }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.updateDate") }}</td>
            <td>{{ $t("DataDetails.mateInfo.latestRelease") }}</td>
            <td>{{ MetaDataInfo.updateTime }}</td>
          </tr>
          <tr>
            <td rowspan="2">
              {{ $t("DataDetails.mateInfo.fileInformation") }}
            </td>
            <td>{{ $t("DataDetails.mateInfo.totalStorage") }}</td>
            <td>{{ MetaDataInfo.storageCapacity }}</td>
          </tr>
          <tr>
            <td>{{ $t("DataDetails.mateInfo.totalFiles") }}</td>
            <td>{{ MetaDataInfo.totalFile }}</td>
          </tr>
        </table>
  </div>
</template>

<script>
import bus from "@/bus";
export default {
  props: ["MetaDataInfo"],
  data() {
    return {
      metaDataInfoVisible: false,
      // btnData: [
      //   {
      //     name: "元数据详情",
      //     iconfont: "iconfont icon-xiangqing3",
      //      border: "1px solid rgba(18, 139, 237, 1)",
      //     background: "#fff",
      //     color: "rgba(18, 139, 237, 1)",
      //   },
      //   {
      //     name: "下载元数据",
      //     iconfont: "iconfont icon-xiazai5",
      //     border: "1px solid rgba(18, 139, 237, 1)",
      //     background: "#fff",
      //     color: "rgba(18, 139, 237, 1)",
      //   },
      // ],
    };
  },
  computed: {
    btnData() {
      return [
        {
          name: this.$t("DataDetails.metadataDetails"),
          iconfont: "iconfont icon-xiangqing3",
          border: "1px solid rgba(18, 139, 237, 1)",
          background: "#fff",
          color: "rgba(18, 139, 237, 1)",
        },
        {
          name: this.$t("DataDetails.downloadMetadata"),
          iconfont: "iconfont icon-xiazai5",
          border: "1px solid rgba(18, 139, 237, 1)",
          background: "#fff",
          color: "rgba(18, 139, 237, 1)",
        },
      ];
    },
    ModouleName() {
      return this.$t("DataDetails.mateInfo.basicInformation");
    },
  },
  methods: {
    handleClose() {
      this.metaDataInfoVisible = false;
    },
    base64(content) {
      return window.btoa(unescape(encodeURIComponent(content)));
    },
    tableToExcel() {
      var excelContent = $("#tableObjs").html();

      var excelFile =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
      excelFile +=
        "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";
      excelFile += "<body><table width='10%'  border='1'>";
      excelFile += excelContent;
      excelFile += "</table></body>";
      excelFile += "</html>";
      var link =
        "data:application/vnd.ms-excel;base64," + this.base64(excelFile);
      var a = document.createElement("a");
      a.download = `${this.MetaDataInfo.productName}元数据信息.xls`;
      a.href = link;
      a.click();
    },
    tableExportExcelFun() {
      this.tableToExcel();
    },
    verifyLogin() {
      return localStorage.getItem("token") && localStorage.getItem("loginName");
    },
    metaDataInfoBtnFun(val) {
      console.log(val);
      if (val == 0) {
        this.metaDataInfoVisible = true;
      } else {
        var userVerifyLogin = this.verifyLogin();
        if (!userVerifyLogin) {
          bus.$emit("LoginDialogEmit");
          return;
        }
        this.tableExportExcelFun();
      }
    },
  },
  components: {
    Button: () => import("@/components/DataDetails/Details/Button.vue"),
    ModuleName: () => import("@/components/DataDetails/Details/ModuleName.vue"),
  },
};
</script>

<style lang="scss" >
.el_dialog_box {
  // overflow-y: auto;
}

.MetaDataInfobox {
  border-bottom: 3px solid #fbfbfb;
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin-top: 80px !important;
  }
  .el-dialog__body {
    padding: 10px 10px;
    // flex: 1;
    height: calc(100vh - 260px);
    // height: 400px;
    overflow-y: auto;
  }
  table {
    border: 1px solid #e5e5e5 !important;
  }
  tr {
    width: 100%;

    // display: flex;
    td {
      font-size: 14px;
      // flex: 1;
      font-size: 14px;
      // border: 1px solid #ccc;
      padding: 10px 20px;
      // border-bottom: none;
    }
    td:first-child {
      white-space: nowrap;
    }
  }
}
.MetaDataInfo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 20px;

  .type_100 {
    width: 100% !important;
    display: flex;
    .nowarp {
      word-break: break-all;
    }
  }
  .type_box {
    margin-top: 20px;
    width: 50%;
    display: flex;
    .type {
      font-size: 14px;
      // min-width: 100px;
      white-space: nowrap;
      text-align: right;
      // color: rgba(153, 153, 153, 1);
      color: rgb(18, 139, 237);
    }
    .key_img {
      border-radius: 2px;
      overflow: hidden;
    }
    .type_val {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      font-size: 14px;
      margin-right: 20px;
      color: rgba(0, 0, 0, 1);
      .arr_for {
        padding: 2px 10px;
        background: #26a6d9;
        color: #fff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
}
.metaDataInfoBtn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>